<template>
  <div class="app-table">
    <div class="table-header row">
      <div class="col-6 title">
        Mostrando
        <select
          v-model="controls.per_page"
          @change="paginate"
          class="paginate-per-page"
        >
          <option value="5">05</option>
          <option value="10">10</option>
          <option value="20">20</option>
        </select>
        &nbsp;
        <slot name="header"> <i class="fas fa-eye"></i> Registros </slot>
      </div>
      <div class="col-6 text-right">
        <button
          v-if="!searching"
          @click="searching = true"
          class="btn btn-primary"
        >
          <i class="fas fa-search"></i>
        </button>
        <button v-else @click="searching = false" class="btn btn-dark">
          <i class="fas fa-angle-double-right"></i>
        </button>
        <!-- @change="paginate" -->
        <input
          v-if="searching"
          v-model="controls.query"
          type="text"
          class="form-control search-input"
          v-on:keyup="paginate"
          @keydown.esc="escapeSearch"
        />
        <b-pagination
          v-if="!searching"
          v-model="controls.current_page"
          :total-rows="controls.total"
          :per-page="controls.per_page"
          @change="paginate"
        >
        </b-pagination>
      </div>
    </div>
    <!-- slot table -->
    <table class="table table-bordered table-striped sin-bordes table-sort">
      <thead>
        <tr>
          <th
            v-for="(f, k) in fields"
            :key="k"
            :class="headerClazz(f)"
            @click="headerSet(f)"
          >
            {{ f.display }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, i) in paginateData" :key="i">
          <slot v-bind:row="row" name="tr-item">
            <td v-for="(f, j) in fields" :key="j">
              <!-- {{ dataRow(row, f) }} -->
              <texto-resaltado :text="dataRow(row, f)" :query="controls.query">
              </texto-resaltado>
            </td>
          </slot>
        </tr>
      </tbody>
    </table>
    <!-- slot footer -->
    <div class="row">
      <div class="col-4">
        <slot name="footer"> </slot>
      </div>
      <div class="col-8 text-right align-bottom">
        <p>
          Página: {{ controls.current_page }} de {{ controls.last_page }},
          mostrando un total de {{ controls.per_page }} registros por página de
          un total de {{ controls.total }} registros.
        </p>
      </div>
    </div>
    <!-- slot footer -->
  </div>
</template>

<script>
export default {
  props: {
    controls: {
      type: Object,
      required: true
    },
    api: {
      type: Object,
      required: true
    },
    fields: {
      type: Array,
      required: true
    }
  },
  model: {
    prop: "controls",
    event: "change"
  },
  data() {
    return {
      paginateData: [],
      searching: false
    };
  },
  created() {
    let defaultCtrls = {
      current_page: 1,
      per_page: 10,
      total: 0,
      query: "",
      sort_column: "id",
      sort_order: "asc"
    };
    Object.assign(defaultCtrls, this.controls); //sobre escribimos los valores por default
    Object.assign(this.controls, defaultCtrls); //reasignamos los valores a controls, por si falta algun campo
    this.paginate();
  },
  methods: {
    paginate() {
      if (this.controls.query && this.controls.query.match(/\s+$/gi)) {
        return;
      }
      this.api.paginate(this.controls).then(r => {
        this.paginateData = r.data.data;
        Object.assign(this.controls, r.data.controls);
        this.$emit("change", this.controls);
      });
    },
    isPaginateField(fieldConfig) {
      return !(
        !Object.prototype.hasOwnProperty.call(fieldConfig, "sort") ||
        !fieldConfig.sort ||
        !Object.prototype.hasOwnProperty.call(fieldConfig, "field")
      );
    },
    headerClazz(fieldConfig) {
      if (!this.isPaginateField(fieldConfig)) {
        return "";
      }
      if (this.controls.sort_column == fieldConfig.field) {
        return this.controls.sort_order;
      }
      return "sort";
    },
    headerSet(fieldConfig) {
      if (!this.isPaginateField(fieldConfig)) {
        return;
      }
      let c = this.controls;
      if (c.sort_column != fieldConfig.field) {
        c.sort_column = fieldConfig.field;
        c.sort_order = "asc";
      } else {
        c.sort_order = c.sort_order == "asc" ? "desc" : "asc";
      }
      return this.paginate();
    },
    escapeSearch() {
      this.controls.query = "";
      this.searching = false;
      return this.paginate();
    },
    dataRow(row, f) {
      if (
        !Object.prototype.hasOwnProperty.call(f, "field") ||
        !Object.prototype.hasOwnProperty.call(row, f.field)
      ) {
        return "";
      }
      return row[f.field] + "";
    }
  } // methods
};
</script>
